<template>
	<div class="gvf">
		<v-switch
			:tabindex="tabIndex"
			:disabled="isNull"
			v-model="value"
			:label="gridViewField.Label"
			class="grid-field"
			hide-details="auto"
			@change="changeValue()"
		/>
		<v-checkbox
			v-if="isBulkEdit"
			v-model="isNull"
			label="Set field to null"
			class="ma-0"
			hide-details
			@change="changeValue()"
		></v-checkbox>
	</div>
</template>
<script>
import gridViewFieldsUtils from '../../../../utils/gridViewFieldsUtils';
import gridFieldMixin from '../../../../mixins/grids/gridFieldMixin';
export default {
	name: 'BooleanField',
	mixins: [gridFieldMixin],
	data() {
		return {
			value: null,
		};
	},
	mounted() {
		if (this.record && this.key && this.record[this.key]) {
			this.value = this.record[this.key];
		}
	},
	methods: {
		changeValue() {
			let recordKey;
			if (this.isNull) {
				recordKey = [{ key: this.key, value: null }];
			} else {
				recordKey = [{ key: this.key, value: this.value }];
			}
			let itemKey = [
				{
					key: gridViewFieldsUtils.getFieldName(this.gridViewField),
					value: this.value,
				},
			];
			this.$emit('valueChanged', itemKey, recordKey, this.isNull);
		},
	},
};
</script>
<style lang="scss">
.gvf .v-input--switch {
	padding-bottom: 4px;
}
</style>
